import React from 'react';
import { Plugins } from '@leverege/plugin';

// eslint-disable-next-line import/prefer-default-export
export const FotaAttributeEditorFactory = Plugins.createFactory('FotaAttributeEditor', {
  strategy: Plugins.reactStrategy(React, null),
  pluginKey: 'editor',
  typeKey: 'valueType'
});